import { LineLayerSpecification } from 'mapbox-gl'

export class MapOutlineLayerFactory {
	static make(source: string = 'shape'): LineLayerSpecification {
		return {
			id: 'Outline',
			type: 'line',
			source,
			paint: {
				'line-color': ['coalesce', ['get', 'cor'], '#FEFEFE'],
				'line-width': ['coalesce', ['get', 'borda'], 2],
			},
		}
	}
}
